import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaSpinner } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import './AuthSuccess.css';

const AuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeSessionFromToken } = useAuth();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!token) {
        toast.error('Sign-in incomplete. Please try again.');
        navigate('/auth', { replace: true });
        return;
      }
      const result = await completeSessionFromToken(token);
      if (cancelled) return;
      if (result.success) {
        setStatus('ok');
        toast.success('Successfully signed in with Google!');
        setTimeout(() => navigate('/', { replace: true }), 1200);
      } else {
        setStatus('error');
        toast.error(result.message || 'Could not complete sign-in');
        navigate('/auth', { replace: true });
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [token, navigate, completeSessionFromToken]);

  return (
    <div className="auth-success-page">
      <div className="auth-success-container">
        <motion.div
          className="success-card"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className="success-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <FaCheckCircle />
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Welcome to GLJewelAcademy!
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            You have successfully signed in. Redirecting you to the homepage...
          </motion.p>
          
          <motion.div
            className="loading-indicator"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            {status === 'loading' ? (
              <>
                <FaSpinner className="spinner" />
                <span>Completing sign-in…</span>
              </>
            ) : (
              <span>Redirecting…</span>
            )}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default AuthSuccess;
